module.exports = "<div *ngIf=\"hasResults\" class=\"scale-chart-container d-flex h-100\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/assessment-charts/summary-scales-chart/summary-scales-chart.component.html
// module id = ./src/app/assessment-charts/summary-scales-chart/summary-scales-chart.component.html
// module chunks = main